export const normalizeVolume = (volume, normalization, typeCurveDetails, wellCompletions) => {
  try {
    let length = Number(wellCompletions?.['Completed_Well_Length_m'] || wellCompletions?.['lateral_length'] || 0);
    let number = Number(wellCompletions?.['Number_of_Clusters'] || wellCompletions?.['number_of_stages'] || 0);
    let tonnage = Number(wellCompletions?.['Tonnage_Entry_Point'] || (wellCompletions?.['proppant_per_stage']) || 0);
    switch(normalization) {
      case 'length':
        if (typeCurveDetails?.length > 0 && length > 0) {
          return Number(volume) * (typeCurveDetails?.length / length);
        } else {
          return null;
        };
      case 'spacing':
        if (typeCurveDetails?.spacing > 0 && 
          length > 0 && 
          number > 0
        ) {
          const spacing = length / number;
          return Number(volume) * (spacing / typeCurveDetails?.spacing);
        } else {
          return null;
        };
      case 'tpm':
        if (typeCurveDetails?.tpm > 0 && 
          tonnage > 0 && 
          length > 0
        ) {
          const tpm = (tonnage * number) / length;
          return Number(volume) * (typeCurveDetails?.tpm / tpm);
        } else {
          return null;
        };
      default:
        return volume;
    };
  } catch (error) {
    console.log(error);
    return null;
  };
};